import React, { useEffect, useState } from "react";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { updateCompanyContact } from "../../../store/actions/Companies/companyActions";
import { industrySector } from "../../constant/industrySector";
import CandidateGDPR from "../Candidate/CandidateGDPR";
import { debounce } from "../../../utils/debounce";
const EditCompanyContact = ({
  showEditContactModal,
  setShowEditContactModal,
  selectedContact,
  token,
  companyContacts,
}) => {
  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
  const [companyContactList, setCompanyContactList] = useState([]);
  useEffect(() => {
      if(companyContacts) {
        setCompanyContactList(companyContacts?.map((itm)=>itm.value))
      }
    }, [companyContacts]);
  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    // Destructure the API response
    const {
      line_1: addressLine1 = "",
      line_2: addressLine2 = "",
      town_or_city: town = "",
      county = "",
      country = "",
      postcode: postCode = "",
      region = "",
    } = result;

    // Update the form data with the new address details
    setFormData((prevFormData) => ({
      ...prevFormData,
      addressLine1,
      addressLine2,
      town,
      county,
      country,
      postCode,
      region,
    }));
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  const fetchData = async (inputQuery) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${inputQuery}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setResults(result.suggestions);
  };

  // Handle input changes
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery); // Update input state
    debounce(fetchData(inputQuery)); // Call the debounced function
  };

  const [searchParams] = useSearchParams();
  const formMode = searchParams.get("mode");
  const isView = formMode === "view";
  const dispatch = useDispatch();
  const tabData = [
    {
      name: "Master",
      icon: "home",
    },
    // {
    //   name: "Classification",
    //   icon: "certificate",
    // },
    {
      name: "GDPR",
      icon: "book-open",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabData[0].name.toLowerCase()); // Set initial active tab
  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const [formData, setFormData] = useState({
    title: selectedContact?.title,
    firstName: selectedContact?.firstName,
    lastName: selectedContact?.lastName,
    knownAs: selectedContact?.knownAs,
    comment: selectedContact?.comment,
    company: selectedContact?.company,
    position: selectedContact?.position,
    currentPosition: selectedContact?.currentPosition,
    accountNumber: selectedContact?.accountNumber,
    addressLine1: selectedContact?.address?.[0]?.addressLine1 || "",
    addressLine2: selectedContact?.address?.[0]?.addressLine2 || "",
    town: selectedContact?.address?.[0]?.town || "",
    county: selectedContact?.address?.[0]?.county || "",
    country: selectedContact?.address?.[0]?.country || "",
    postCode: selectedContact?.address?.[0]?.postcode || "",
    region: selectedContact?.address?.[0]?.region || "",
    phone: selectedContact?.contact?.phoneType || "",
    phoneNumber: selectedContact?.contact?.phoneNumber || "",
    email: selectedContact?.email || "",
    office: selectedContact?.office || "",
    sector: selectedContact?.sector || "",
    personId: selectedContact?.personId || "",
    consultant: selectedContact?.consultant || "",
    regDate: selectedContact?.regDate ? new Date(selectedContact?.regDate) : "",
    source: selectedContact?.source || "",
    statusDate: selectedContact?.statusDate
      ? new Date(selectedContact?.statusDate)
      : null,
    status: selectedContact?.status || "",
    category: selectedContact?.category || "",
    companyId: selectedContact?.companyId || "",
    industrySector: selectedContact?.industrySector || "",
    jobTitles: selectedContact?.jobTitles || "",
    skills: selectedContact?.skills || "",
    qualifications: selectedContact?.qualifications || "",
    marketing: selectedContact?.marketing || "",
    gdpr: selectedContact?.gdpr,
  });
  const [errors, setErrors] = useState({});
  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" }); // Clear specific field error
  };
  const validate = () => {
    const newErrors = {};
    if (activeTab === "master") {
      // Required fields
      // const requiredFields = [
      //   "title",
      //   "firstName",
      //   "lastName",
      //   "postCode",
      //   "town",
      //   "country",
      //   "email",
      //   "phone",
      //   "phoneNumber",
      // ];

      // requiredFields.forEach((field) => {
      //   if (!formData[field].trim()) {
      //     newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      //   }
      // });

      // Email validation
      if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email must be valid.";
      }

      // Phone and Phone Number validation
      // if (!formData.phone) {
      //   newErrors.phone = "Phone type is required.";
      // }
      if (
        formData.phoneNumber && 
        !/^(?:\+44|0)\d{10}$/.test(formData.phoneNumber)
      ) {
        newErrors.phoneNumber = "Phone Number must be a valid UK mobile number.";
      }
    }
    // if (activeTab === "classification") {
    //   if (!formData.industrySector) {
    //     newErrors.industrySector = "Please select industry sector.";
    //   }
    // }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        ...formData,
        title: formData?.title,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        knownAs: formData?.knownAs,
        address: [
          {
            addressType: "HOME",
            isDefault: true,
            addressLine1: formData?.addressLine1,
            addressLine2: formData?.addressLine2,
            addressLine3: "",
            town: formData?.town,
            county: formData?.county,
            country: formData?.country,
            postcode: formData?.postCode,
            region: formData?.region,
          },
        ],
        contact: {
          phoneType: formData?.phone,
          phoneNumber: formData?.phoneNumber,
        },
        email: formData?.email?.toLowerCase(),
        website: "",
        business: "Rapid Resourcing Ltd",
        office: "Liverpool",
        sector: formData?.sector,
        personId: formData?.personId,
        consultant: formData?.consultant,
        regDate: formData?.regDate,
        source: formData?.source,
        statusDate: formData?.regDate,
        status: formData?.status,
        comment: formData?.comment,
        category: formData?.category,
        company: formData?.company,
        companyId: formData?.companyId,
        position: formData?.position,
        currentPosition: formData?.currentPosition,
        accountNumber: formData?.accountNumber,
      };
      dispatch(updateCompanyContact(payload, selectedContact?._id, token));
    }
  };
  return (
    <Modal
      className="fade bd-example-modal-lg"
      show={showEditContactModal}
      size="lg"
      onHide={() => setShowEditContactModal(false)}
    >
      <Modal.Header>
        <Modal.Title>Edit Contact</Modal.Title>
        <Button
          variant=""
          className="btn-close"
          onClick={() => setShowEditContactModal(false)}
        ></Button>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
            <Nav as="ul" className="nav-tabs">
              {tabData.map((data, i) => (
                <Nav.Item as="li" key={i}>
                  <Nav.Link eventKey={data.name.toLowerCase()}>
                    <i className={`la la-${data.icon} me-2`} />
                    {data.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <Tab.Content className="pt-4">
              <Tab.Pane eventKey="master" key={1}>
                <div>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {[
                        {
                          label: "Title",
                          field: "title",
                          type: "select",
                          required: false,
                          options: ["", "Mr.", "Mrs.", "Ms."],
                        },
                        {
                          label: "First Name",
                          field: "firstName",
                          required: false,
                        },
                        {
                          label: "Last Name",
                          field: "lastName",
                          required: false,
                        },
                        {
                          label: "Known As",
                          field: "knownAs",
                          required: false,
                        },
                        // { label: "Company", field: "company", required: false },
                        { label: "Position", field: "currentPosition", required: false },
                        { label: "Contact Type", field: "position", required: false, type: "select", options: ["", ...companyContactList] },

                        // {
                        //   label: "Category",
                        //   field: "category",
                        //   required: false,
                        // },
                        // {
                        //   label: "Account Number",
                        //   field: "accountNumber",
                        //   required: false,
                        // },
                        {
                          label: "Address Line 1",
                          field: "addressLine1",
                          required: false,
                        },
                        { label: "Address Line 2", field: "addressLine2" },
                        { label: "Town", field: "town", required: false },
                        { label: "County", field: "county", required: false },
                        { label: "Country", field: "country", required: false },
                        {
                          label: "Post Code",
                          field: "postCode",
                          required: false,
                        },
                        // { label: "Region", field: "region", required: false },
                        {
                          label: "Phone Type",
                          field: "phone",
                          type: "select",
                          options: ["", "Home", "Mobile"],
                          required: false,
                        },
                        {
                          label: "Phone Number",
                          field: "phoneNumber",
                          required: false,
                        },
                        {
                          label: "Email",
                          field: "email",
                          type: "email",
                          required: false,
                        },
                        // { label: "Office", field: "office", required: false },
                        // { label: "Sector", field: "sector", required: false },
                        {
                          label: "Person ID",
                          field: "personId",
                          required: false,
                          disabled: false
                        },
                        // { label: "Source", field: "source", required: false },
                      ].map(
                        ({
                          label,
                          field,
                          type = "text",
                          required = false,
                          options = [],
                          disabled = false
                        }) => (
                          <div className="col-xl-6 mb-3" key={field}>
                            {type === "select" ? (
                              <>
                                <label className="form-label">
                                  {label}{" "}
                                  {required && (
                                    <span className="text-danger">*</span>
                                  )}
                                </label>
                                <select
                                  className="form-control"
                                  value={formData[field]}
                                  disabled={disabled}
                                  onChange={(e) =>
                                    handleInputChange(field, e.target.value)
                                  }
                                >
                                  {options?.map((itm) => (
                                    <option value={itm}>{itm}</option>
                                  ))}
                                </select>
                              </>
                            ) : (
                              <>
                                <label className="form-label">
                                  {label}{" "}
                                  {required && (
                                    <span className="text-danger">*</span>
                                  )}
                                </label>
                                <input
                                  type={type}
                                  disabled={disabled}
                                  className="form-control"
                                  value={formData[field]}
                                  onChange={(e) =>
                                    handleInputChange(field, e.target.value)
                                  }
                                />
                              </>
                            )}
                                      {field === "postCode" && results?.length > 0 && (
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                maxHeight: "150px", // Medium size scrollable div
                                overflowY: "auto",
                                marginTop: "5px",
                                padding: "10px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {results?.map((suggestion, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "5px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  } // Handle click on suggestion
                                >
                                  {suggestion.address}
                                </div>
                              ))}
                            </div>
                          )}
                            {errors[field] && (
                              <small className="text-danger">
                                {errors[field]}
                              </small>
                            )}
                          </div>
                        )
                      )}
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Registration Date</label>
                        <br />
                        <DatePicker
                          className="form-control"
                          selected={formData.regDate}
                          onChange={(date) =>
                            handleInputChange("regDate", date)
                          }
                          dateFormat="dd/MM/yyyy"
                        />
                        {errors.regDate && (
                          <small className="text-danger">
                            {errors.regDate}
                          </small>
                        )}
                      </div>
                      {/* <div className="col-xl-6 mb-3">
                        <label className="form-label">Status Date</label>
                        <br />
                        <DatePicker
                          className="form-control"
                          selected={formData.statusDate}
                          onChange={(date) =>
                            handleInputChange("statusDate", date)
                          }
                        />
                        {errors.statusDate && (
                          <small className="text-danger">
                            {errors.statusDate}
                          </small>
                        )}
                      </div> */}
                      {/* <div className="col-xl-6 mb-3">
                        <label className="form-label">Status</label>
                        <select
                          className="default-select form-control"
                          value={formData.status}
                          onChange={(e) =>
                            handleInputChange("status", e.target.value)
                          }
                        >
                          <option value="PRE-REG" selected>
                            PRE-REG
                          </option>
                          <option value="LIVE">LIVE</option>
                          <option value="ARCHIVED">ARCHIVED</option>
                          <option value="GDPR REMOVED">GDPR REMOVED</option>
                          <option value="PLACED">PLACED</option>
                          <option value="NOT LOOKING FOR WORK">
                            NOT LOOKING FOR WORK
                          </option>
                        </select>
                      </div> */}
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Comment </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.comment}
                          onChange={(e) =>
                            handleInputChange("comment", e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <button type="submit" className="btn btn-primary me-1">
                        Save
                      </button>
                      <Link
                        to={"#"}
                        onClick={() => setShowEditContactModal(false)}
                        className="btn btn-danger light ms-1"
                      >
                        Cancel
                      </Link>
                    </div>
                  </form>
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey="classification" key={2}>
                <div>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Industry Sector <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control form-select"
                          value={formData.industrySector}
                          disabled={isView}
                          onChange={(e) =>
                            handleInputChange("industrySector", e.target.value)
                          }
                        >
                          <option value=""></option>
                          {industrySector?.map((itm) => (
                            <option value={itm}>{itm}</option>
                          ))}
                        </select>
                        {errors.industrySector && (
                          <small className="text-danger">
                            {errors.industrySector}
                          </small>
                        )}
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Job Titles</label>
                        <select
                          className="form-control form-select"
                          value={formData.jobTitles}
                          disabled={isView}
                          onChange={(e) =>
                            handleInputChange("jobTitles", e.target.value)
                          }
                        >
                          <option value=""></option>
                          <option value="Test">Test</option>
                        </select>
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Skills</label>
                        <select
                          className="form-control form-select"
                          value={formData.skills}
                          disabled={isView}
                          onChange={(e) =>
                            handleInputChange("skills", e.target.value)
                          }
                        >
                          <option value=""></option>
                          <option value="Test">Test</option>
                        </select>
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Qualification</label>
                        <select
                          className="form-control form-select"
                          value={formData.qualifications}
                          disabled={isView}
                          onChange={(e) =>
                            handleInputChange("qualifications", e.target.value)
                          }
                        >
                          <option value=""></option>
                          <option value="Graduate">Graduate</option>
                        </select>
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Marketing</label>
                        <select
                          className="form-control form-select"
                          value={formData.marketing}
                          disabled={isView}
                          onChange={(e) =>
                            handleInputChange("marketing", e.target.value)
                          }
                        >
                          <option value=""></option>
                          <option value="Opt-in">Opt-in</option>
                          <option value="Opt-out">Opt-out</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      {isView ? null : (
                        <button type="submit" className="btn btn-primary me-1">
                          Update
                        </button>
                      )}
                      <button
                        onClick={() => {
                          setShowEditContactModal(false);
                        }}
                        className="btn btn-danger light ms-1"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="gdpr" key={3}>
                <CandidateGDPR
                  formData={formData}
                  isView={isView}
                  handleInputChange={handleInputChange}
                  submit={handleSubmit}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    companyContacts: state?.dropDownValues?.dropDownValues?.companyContacts || [],
  };
};

export default withRouter(connect(mapStateToProps)(EditCompanyContact));
